import React from 'react';
import numeral from 'numeral';
import Emptystate from './_empty';
import { Rating } from 'components';
import { MdDelete } from 'react-icons/md';

const format = (a) => numeral(a).format('0,0.00');

export default ({ cartItems=[], onRemoveItem, onChangeQuantity }) => {

  if (cartItems.empty()) return <Emptystate/>

  const mobile_mode = (window.screen.width < 720);

  return (
    <div className='Product-List'>
      { cartItems.map((item,index) =>
          <Product
            {...item}
            mobile={mobile_mode}
            key={index.toString()}
            onRemoveItem={onRemoveItem}
            onChangeQuantity={onChangeQuantity}
          />
        )
      }
    </div>
  )
}

const Product = (props) => {

  const  handle_change = (e) => {
    const { value } = e.target;
    if (!value || value<1) return;
    return props.onChangeQuantity(value,props.handle);
  }

  const View = (!props.mobile) ? Desktop : Mobile;

  return (<View {...props} onChangeQuantity={handle_change}/>);

}

const Desktop = (props) => {

  const {
    handle,
    stock,
    title,
    pricing,
    images=[],
    quantity=1,
    category,
    sku,
    vendor,
    onRemoveItem,
    onChangeQuantity
  } = props;

  return (
    <div className='Cart-Item Desktop'>

      <div
        className='Item-Image'
        style={{ backgroundImage: `url(${images[0]})`}}
      />

      <div className="Item-Information">

        <div className="Item-Name">{title}</div>

        <div className="Item-Metadata">
          <span>{vendor}</span>
          <span>{category}</span>
          <span>{sku}</span>
        </div>

        <div className="Reviews">
          <Rating/>
          <span>15468</span>
        </div>

        <div className="Btn-Remove" onClick={() => onRemoveItem(handle)}>
          <MdDelete className='icon'/>
          <span>Remove Item</span>
        </div>

      </div>

      <div className="Sale-Information">

        <div className="Item-Price">{format(pricing.price)}</div>

        { (pricing.compare>0) &&
          <div className="Item-Price-Compare">Ksh {format(pricing.compare)}</div>
        }

        <div className="Item-Count">

          <div className="Label">Quantity</div>

          <input
            min='1'
            max={stock}
            type="number"
            value={quantity}
            className="Value"
            onChange={onChangeQuantity}
          />

        </div>

      </div>

    </div>
  )
}

const Mobile = (props) => {
  const {
    handle,
    stock,
    title,
    pricing,
    images=[],
    quantity=1,
    onRemoveItem,
    onChangeQuantity
  } = props;
  return (
    <div className='Cart-Item Mobile'>

      <div className="Sale-Information">

        <div
          className='Item-Image'
          style={{ backgroundImage: `url(${images[0]})`}}
        />

        <div className="Item-Count">
          <div className="Label">Quantity</div>
          <input
            min='1'
            max={stock}
            type="number"
            value={quantity}
            className="Value"
            onChange={onChangeQuantity}
          />
        </div>

      </div>

      <div className="Item-Information">

        <div className="Item-Name">{title}</div>

        <div className="Item-Price">{format(pricing.price)}</div>

        { (pricing.compare>0) &&
          <div className="Item-Price-Compare">Ksh {format(pricing.compare)}</div>
        }

        <div className="Btn-Remove" onClick={() => onRemoveItem(handle)}>
          <MdDelete className='icon'/>
          <span>Remove Item</span>
        </div>

      </div>

    </div>
  )
}
